import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(main)/create-cv/loading.tsx");
